import { Group } from '@mantine/core';

type RootPropsType = {
  children: React.ReactNode;
};

export const Root: React.FC<RootPropsType> = ({ children }) => {
  return (
    <Group justify="center" gap={5}>
      {children}
    </Group>
  );
};
